import { useNavigate } from "react-router";
import {
  Button,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";
import { ArrowLeft20Regular } from "@fluentui/react-icons";
import { RisikoImmoForm } from "../components/RisikoImmoForm";

const useStyles = makeStyles({
  root: {
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "16px",
    paddingRight: "16px",
    "@media (min-width: 768px)": {
      paddingTop: "24px",
      paddingBottom: "24px",
      paddingLeft: "24px",
      paddingRight: "24px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    columnGap: "12px",
    marginBottom: "16px",
  },
  legacyBadge: {
    display: "inline-flex",
    alignItems: "center",
    paddingTop: "3px",
    paddingBottom: "3px",
    paddingLeft: "8px",
    paddingRight: "8px",
    backgroundColor: "rgba(247,168,35,0.18)",
    color: "#7a4c00",
    fontSize: "0.7rem",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    ...shorthands.borderRadius("999px"),
  },
});

const RisikoImmobilieLegacyPage = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Button
          appearance="subtle"
          icon={<ArrowLeft20Regular />}
          onClick={() => navigate("/risks/new")}
        >
          Zurück
        </Button>
        <h2 style={{ margin: 0 }}>Immobilie erfassen — Alte Ansicht</h2>
        <span className={styles.legacyBadge}>Legacy</span>
      </div>
      <RisikoImmoForm />
    </div>
  );
};

export default RisikoImmobilieLegacyPage;
